import React, { useState, useEffect } from "react";
import { useParams, Outlet, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Navbar from "components/Navbar";
import styles from "styles/Layout.module.css";
import sidebar from "styles/Sidebar.module.css";
import {
    Box,
    Collapse,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    styled,
    Tooltip,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import {
    ExpandLess,
    ExpandMore,
} from "@mui/icons-material";
import { useGetProjectDetailQuery } from "store/slices/apis/projectApiSlice";
import projectMenus from "components/menu-items";
import PageMenu from "components/PageMenu";

import ProjectFooter from "./ProjectFooter";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";
import { ReactComponent as BUildingIcon } from "assets/PwC_Funct_Icons_Building_Outline_Black_RGB.svg"
import { useAuth } from "context/AuthContext";
import { MAIN_ROLES } from "config";
import { useGetProjectPermissionQuery } from "store/slices/apis/projectPermissionSlice";

const DrawerHeader = styled('div')(({ theme, align }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    justifyContent: align ? 'flex-end' : 'center',
}));

const ProjectLayOut = (props) => {
    const theme = useTheme();

    const [searchParams] = useSearchParams();
    const { hasPermission, hasRoleCheck } = useCheckMenuPermission();

    const { leftMenuData } = props;
    const { user, setUser, getProjectPermissionInfo } = useAuth();

    const { menu, "*": submenu } = useParams();
    const { projectId } = useParams();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [currentMenu, setCurrentMenu] = useState(null);
    const { data: projectDetail } = useGetProjectDetailQuery(projectId);

    const [mainRoute, setMainRoute] = useState(null);
    const isMobile = useMediaQuery('(max-width:768px)');

    const toHyphenatedLowerCase = (str) => {
        return str?.split(" ")?.join("-")?.toLowerCase();
    };

    // Toggle submenu expansion
    const handleExpand = (menu) => {
        setExpandedMenus((prev) => {
            const newExpandedMenus = {};
            newExpandedMenus[menu] = !prev[menu]; // Toggle the selected menu
            return newExpandedMenus;
        });
        setOpen(true)
    };

    const [expandedMenus, setExpandedMenus] = useState({});

    useEffect(() => {
        const formattedMenu = toHyphenatedLowerCase(menu);
        const selectedMenu = projectMenus?.topMenus.find(
            (m) => toHyphenatedLowerCase(m.menu) === formattedMenu
        );

        setCurrentMenu(selectedMenu || projectMenus?.topMenus?.[0]);

        if (selectedMenu && !submenu) {
            navigate(`/${formattedMenu}/${selectedMenu.submenus[0].route}`);
        }
    }, [menu, submenu, navigate]);

    useEffect(() => {
        if (user?.permission == undefined) {
            getProjectPermissionInfo(projectId)
        }
    }, [])

    // useEffect(() => {
    //     const contentDiv = document.querySelector(`.${styles.content}`);
    //     if (searchParams?.size > 0) {
    //         contentDiv.style.padding = "0";
    //     } else {
    //         contentDiv.style.padding = "0px 32px 20px 32px";
    //     }
    // }, [searchParams]);

    const handleDrawerClose = () => {
        setOpen(!open);
    };
    const handleClickAway = () => {
        if (open) {
            setOpen(false)
        }
    };
    const decrypt = (encoded) => decodeURIComponent(escape(atob(encoded)));
    return (
        <div className={styles.layout}>
            <Navbar menus={projectMenus?.topMenus} handleDrawer={handleDrawerClose} handleClickAway={handleClickAway} isOpen={open} />
            <div className={styles.main} style={{ gap: isMobile ? '0px' : '0px' }}>
                <div className={`${sidebar.sidebar}`}>
                    <Drawer

                        variant="permanent"
                        open={open}
                        sx={{
                            width: open ? 240 : 0,
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                width: open ? isMobile ? '100%' : 240 : 0,
                                boxSizing: 'border-box',
                                transition: 'width 0.3s ease',
                                marginTop: '63px',
                                backgroundColor: '#f3f3f3',
                                border: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                height: 'calc(100vh - 63px)', // ensure it doesn't exceed the screen
                                overflow: 'hidden', // hide overflow except list
                            },
                        }}
                    >
                        <DrawerHeader align={open}>
                            {/* <IconButton onClick={handleDrawerClose}>
                                    {open ? <MdOutlineMenuOpen style={{ height: '25px', width: '25px' }} /> : <IoMenu style={{ height: '25px', width: '25px' }} />}
                                </IconButton> */}
                        </DrawerHeader>
                        <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>

                            <List
                                sx={{
                                    paddingTop: 0
                                }}>
                                <Tooltip
                                    placement="right"
                                    title={projectDetail?.data?.project_name ?? ""}
                                    arrow
                                    slotProps={{
                                        tooltip: { sx: { fontSize: "12px" } },
                                    }}
                                >
                                    <ListItemButton
                                        sx={{
                                            bgcolor: "inherit",
                                            paddingLeft: open
                                                ? isMobile
                                                    ? '10px'
                                                    : '16px'
                                                : '16px',
                                            borderRadius: "4px",
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                            justifyContent: open ? 'start' : 'center',
                                            ':hover': {
                                                background: 'none'
                                            },
                                            cursor: 'auto',
                                            '& .MuiListItemIcon-root': {
                                                justifyContent: open ? 'start' : 'center'
                                            }
                                        }}
                                    >

                                        <ListItemIcon
                                            sx={{
                                                minWidth: "30px",
                                                "& svg": {
                                                    height: "16px",
                                                    width: "16px",
                                                },
                                            }}
                                        >
                                            <BUildingIcon style={{
                                                height: '30px', width: '50px'
                                            }} />
                                            {/* <div>
                                                    <img src={airport} style={{ height: '50px', width: '50px' }} />
                                                </div> */}
                                        </ListItemIcon>


                                        {open && (
                                            <ListItemText
                                                primary={projectDetail?.data?.project_name ?? ""}
                                                sx={{
                                                    height: "45px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    overflow: "hidden",
                                                    // whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis",
                                                    margin: 0,
                                                }}
                                            />
                                        )}
                                    </ListItemButton>
                                </Tooltip>
                                {leftMenuData.filter(item => hasPermission(item?.permissionKey) > 0 || !item?.permissionKey || hasRoleCheck() > 0)
                                    ?.map((item) => {

                                        const mainActiveMenu = (() => {
                                            if (item.route === "") {
                                                return location.pathname === `/projects/${projectId}`;
                                            } else {
                                                if (item.route && item.route !== false) {
                                                    return location.pathname.endsWith(
                                                        `/projects/${projectId}/${item.route}`
                                                    );
                                                }
                                                return false;
                                            }
                                        })();

                                        return (
                                            <React.Fragment key={item.menu}>
                                                <ListItemButton
                                                    onClick={() => {
                                                        if (item.submenus?.length > 0) {
                                                            handleExpand(item.menu)
                                                        } else {
                                                            navigate(item.route
                                                                ? `/projects/${projectId}/${item.route}`
                                                                : `/projects/${projectId}?type=${decrypt(localStorage.getItem('projectUrl'))}`)
                                                            if (open) {
                                                                setOpen(false)
                                                            }
                                                        }
                                                    }

                                                        // item.submenus
                                                        //     ? handleExpand(item.menu)
                                                        //     : navigate(item.route
                                                        //         ? `/projects/${projectId}/${item.route}`
                                                        //         : `/projects/${projectId}?type=${decrypt(localStorage.getItem('projectUrl'))}`)
                                                    }
                                                    sx={{
                                                        bgcolor: mainActiveMenu ? "#E8E8E8" : "inherit",
                                                        borderRadius: "4px",
                                                        justifyContent: open ? 'start' : 'center',
                                                        paddingLeft: open
                                                            ? isMobile
                                                                ? '10px'
                                                                : '26px'
                                                            : '16px',
                                                        '& .MuiListItemIcon-root': {
                                                            justifyContent: open ? 'start' : 'center'
                                                        }
                                                    }}
                                                >
                                                    <Tooltip
                                                        placement="right"
                                                        title={!open ? item.menu : ''}
                                                        arrow
                                                        slotProps={{
                                                            tooltip: { sx: { fontSize: "12px" } },
                                                        }}
                                                    >
                                                        <ListItemIcon
                                                            sx={{
                                                                minWidth: "30px",
                                                                "& svg": {
                                                                    height: "16px",
                                                                    width: "16px",
                                                                },
                                                            }}
                                                        >
                                                            {item.icon ? (
                                                                item.icon
                                                            ) : (
                                                                <>
                                                                    {/* <img src={item?.img} alt={item?.menu} style={{ height: '50px', width: '50px' }} /> */}
                                                                </>
                                                            )}
                                                        </ListItemIcon>
                                                    </Tooltip>

                                                    {open && (
                                                        <ListItemText
                                                            primary={item.menu}
                                                            sx={{
                                                                "& .MuiTypography-root": { fontSize: { xs: '14px', sm: "16px" } },
                                                            }}
                                                        />
                                                    )}
                                                    {item.submenus && open &&
                                                        (expandedMenus[item.menu] ? (
                                                            <ExpandLess />
                                                        ) : (
                                                            <ExpandMore />
                                                        ))}
                                                </ListItemButton>

                                                {/* Render Submenus */}
                                                {item.submenus && open && (
                                                    <Collapse
                                                        in={expandedMenus[item.menu]}
                                                        timeout="auto"
                                                        unmountOnExit
                                                    >
                                                        <List component="div" disablePadding>
                                                            {item?.submenus
                                                                .filter((sub, ind) => hasPermission([item?.permissionKey?.[ind]]) > 0 || !item?.permissionKey || hasRoleCheck() > 0)
                                                                ?.map((sub) => {
                                                                    const isActive = location.pathname.includes(
                                                                        `/projects/${projectId}/${item.route}/${sub.route}`
                                                                    );

                                                                    return (
                                                                        <ListItemButton
                                                                            key={sub.route}
                                                                            sx={{
                                                                                pl: open ? 7 : 2,
                                                                                bgcolor: isActive ? "#e8e8e8" : "inherit",
                                                                                borderRadius: "4px",
                                                                                marginTop: "2px"
                                                                            }}
                                                                            onClick={() => {
                                                                                if (item.route) {
                                                                                    navigate(
                                                                                        `/projects/${projectId}/${item.route}/${sub.route}`
                                                                                    )
                                                                                } else {
                                                                                    navigate(
                                                                                        `/projects/${projectId}/${sub.mainRoute}/${sub.route}`
                                                                                    )
                                                                                }
                                                                                if (open) {
                                                                                    setOpen(false)
                                                                                }
                                                                                // setMainRoute(sub.mainRoute);
                                                                            }

                                                                            }
                                                                        >
                                                                            <ListItemText
                                                                                primary={sub.name}
                                                                                sx={{
                                                                                    "& .MuiTypography-root": {
                                                                                        fontSize: { xs: '14px', sm: "16px" },
                                                                                        fontWeight: isActive ? "500" : "normal",
                                                                                    },
                                                                                }}
                                                                            />
                                                                        </ListItemButton>
                                                                    );
                                                                })}
                                                        </List>
                                                    </Collapse>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                            </List>
                        </Box>
                    </Drawer>
                </div>
                <div className={styles.content} style={{
                    display: open
                        ? isMobile
                            ? 'none'
                            : 'flex'
                        : 'flex', flexDirection: 'column', paddingLeft: isMobile && '10px', paddingRight: isMobile && '10px'
                }}>
                    <PageMenu mainRoute={mainRoute} />
                    <div style={{ flex: 1 }}>
                        <Outlet />
                    </div>
                    <ProjectFooter />
                </div>
            </div>
        </div>
    );
};

export default ProjectLayOut;
